import React, { useState, useEffect } from "react";
import { FiArrowUp, FiArrowDown } from "react-icons/fi";
import { useSelector, useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";

import * as jobsActions from "../../Redux/Actions/jobs";
import { toastMessage } from "../../utils/toast";
import { useSortableData } from "../../utils/sortableData";
import { clearSession } from "../../utils/initiate";
import { onMessageListener } from "../../utils/pushNotification";
import Warning from "../Ui/400";
import ReactPaginate from "react-paginate";
import * as formActions from "../../Redux/Actions/form";
import IFrameModal from "../Ui/IFrameModal/IFrameModal";
import DeleteModal from "../Ui/DeleteModal/DeleteModal";
import "../../assets/table.css";
import DataCount from "../../utils/dataCount";
import { getLocaleValue } from "../../utils";
import Pagination from "./pagination";
import CustomPagination from "./pagination";

const JobsManagement = ({ history }) => {
  let itemsPerPage = 10;
  const [data, setData] = useState([]);
  const [copyData, setCopyData] = useState([]);
  const [type, setType] = useState("");
  const [jobSelectedStatus, setJobSelectedStatus] = useState("All");
  const [loading, setLoading] = useState(false);
  const [errStatus, setErrStatus] = useState(200);
  const dispatch = useDispatch();
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const { t } = useTranslation();
  const [formLang, setFormLang] = useState("");
  const { items, requestSort, sortConfig } = useSortableData(data);
  const [iFrameURL, setIFrameURL] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showIFrameModal, setShowIFrameModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteButtonLoading, setDeleteButtonLoading] = useState(false);
  const [menuId, setMenuId] = useState(0);
  const [isOnUpdate, setIsOnUpdate] = useState(false);
  const [isOnView, setIsOnView] = useState(false);
  const [isOnPay, setIsOnPay] = useState(false);
  const [isOnDelete, setIsOnDelete] = useState(false);
  const [offSetValue, setOffsetValue] = useState(1);
  const [totalCount, setTotalcount] = useState(0);
  const [dataFrom, setDataFrom] = useState(0);
  const [isOnAddtionalPayment, setIsOnAdditionalPayment] = useState(false);

  var language = localStorage.getItem("i18nextLng");
  const userData = useSelector(({ User }) => User.data);

  useEffect(() => {
    if(localStorage.getItem("ErroredJobUrl")){
      let baseurl = localStorage.getItem("ErroredJobUrl");
      let fullUrl = `${baseurl}&token=${window.localStorage.jwt}&lang=${formLang}`;
      handleFormEditUrl(fullUrl);
      setShowIFrameModal(true);

      }
  }, []);
 

  useEffect(() => {
    handleGetAllJobs();
    setDataFrom((offSetValue - 1) * 10 + 1);
  }, [offSetValue, jobSelectedStatus]);

  useEffect(() => {
    language === "arabic" ? setFormLang("ar") : setFormLang("en");
  }, [language]);

  const handleGetAllJobs = () => {
    setLoading(true);

    jobsActions
      .getIndividualJob(
        userData.UserId,
        itemsPerPage,
        offSetValue,
        jobSelectedStatus == "All" ? "" : jobSelectedStatus
      )
      .then((res) => {
        if (res && res.data) {
          // dispatch(jobsActions.getJobData(res.data));
          setData(res.data?.records);
          setCopyData(res.data?.records);
          setTotalcount(res.data?.totalRows);
          let count = res.data?.totalRows / itemsPerPage;
          setPageCount(count);
        } else {
          setData([]);
          toastMessage(
            "error",
            (res && res.message) || `Unable to load the jobs`
          );
        }
        setLoading(false);
        setType("");
      })
      .catch((err) => {
        console.log(err);
        setErrStatus(err.response?.status);
        err.response?.status === 401 && clearSession(dispatch, history);
      });
  };
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items.slice(itemOffset, endOffset));
    // setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, items, jobSelectedStatus]);

  const handlePageClick = (event) => {
    setOffsetValue(event);
    // const newOffset = (event.selected * itemsPerPage) % data.length;
    // console.log(newOffset);
    // setItemOffset(newOffset);
  };

  useEffect(() => {
    // if (jobSelectedStatus === "All") {
    setData(copyData);
    // } else if (jobSelectedStatus === "Draft") {
    //   let items = copyData.filter(
    //     ({ status }) => status === "Draft" || status === "Awaiting Payment"
    //   );
    //   setData(items);
    // } else if (jobSelectedStatus === "Pending") {
    //   let items = copyData.filter(
    //     ({ status }) =>
    //       status === "Agent Selection InProgress" ||
    //       status === "Assigned To Typing Center" ||
    //       // status === "Pending" ||
    //       status === "Awaiting Response" ||
    //       status === "RequestCancellation" ||
    //       status === "RequestCompletion" ||
    //       // status === "Payment" ||
    //       status === "Payment Refund Requested"
    //   );
    //   setData(items);
    // } else if (jobSelectedStatus === "Completed") {
    //   let items = copyData.filter(
    //     ({ status }) => status === "Cancelled" || status === "Completed"
    //   );
    //   setData(items);
    // }
  }, [jobSelectedStatus]);

  useEffect(() => {
    data.map((data) => {
      let status = data.status;
      let arcKey;
      switch (status) {
        case "Completed":
          arcKey = "extra.job_summary_status_completed";
          break;
        case "Pending":
          arcKey = "extra.job_summary_status_pending";
          break;
        case "Draft":
          arcKey = "extra.draft";
          break;
        case "Cancelled":
          arcKey = "extra.job_summary_status_cancelled";
          break;
        case "Awaiting Response":
          arcKey = "extra.home_drawer_awaiting_response";
          break;
        case "Awaiting Payment":
          arcKey = "extra.home_drawer_awaiting_payment";
          break;
        case "Agent Selection InProgress":
          arcKey = "extra.job_summary_status_agentSelectionInProgress";
          break;
        case "Assigned To Typing Center":
          arcKey = "extra.job_summary_status_assignedToTypingCenter";
          break;
        case "RequestCompletion":
          arcKey = "extra.job_summary_status_requestCompletion";
          break;
        case "RequestCancellation":
          arcKey = "extra.job_summary_status_requestCancellation";
          break;
        case "Payment":
          arcKey = "extra.job_summary_status_payment";
          break;
        case "Payment Refund Requested":
          arcKey = "extra.job_summary_status_refund_requested";
          break;
        default:
          arcKey = "";
      }
      data["arcKey"] = arcKey;
      return data;
    });
  }, [data]);

  const handleFormEditUrl = (formURL) => {
    setIFrameURL(
      `${formURL}&token=${window.localStorage.jwt}&lang=${formLang}`
    );
  };

  const handleFormDelete = () => {
    setDeleteButtonLoading(true);
    formActions
      .formDelete(deleteId)
      .then((res) => {
        if (res && res.data) {
          // toastMessage(`success`,`Job Request Deleted Successfully`);
          window.location.reload();
        }
        setDeleteButtonLoading(false);
      })
      .catch((err) => {
        setDeleteButtonLoading(false);
        setErrStatus(err.response);
        err?.response?.status === 401 && clearSession(dispatch, history);
      });
  };

  onMessageListener()
    .then((payload) => {
      let type = payload.data.type;
      let jobId = payload.data.jobID == "0" ? null : payload.data.jobID;

      if (type == "REQUEST_SUBMIT") {
        window.location.reload();
      } else if (type == "AWAITING_PAYMENT") {
        history.push(`/checkout/${jobId}`);
      } else if (type == "PAYMENT_COMPLETE" || type == "PAYMENT_FAILED") {
        history.push("/jobs");
      }
    })
    .catch((err) => {
      setErrStatus(err?.response?.status);
      err?.response?.status === 401 && clearSession(dispatch, history);
    });

  const handleFormClose = () => {
    localStorage.removeItem("ErroredJobUrl");
    setShowIFrameModal(false);
  };

  if (errStatus === 401) {
    return <Warning history={history} />;
  }

  const handleDeleteModalClose = () => {
    setDeleteId("");
    setShowDeleteModal(false);
  };

  return (
    <>
      {type === "" && (
        <div className="container-fluid">
          <div className="page-title-box">
            <h4 className="page-title my-2">
              {getLocaleValue("Job Management")}
            </h4>
          </div>
          {/* <div className='card'>        
                    <iframe id='fr' name="FormData" width='100%' height={'500px'} src ={iFrameUrl} allow=""></iframe>
                </div> */}
          <div className="row">
            <div className="col-lg-12 col-xxl-12">
              <div
                className="d-flex justify-content-center"
                style={{ marginTop: "10px" }}
              >
                <div
                  className="col-md-3"
                  style={{
                    backgroundColor:
                      jobSelectedStatus == "All" ? "white" : "#2d207d",
                    marginRight: "1px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOffsetValue(1);
                    setJobSelectedStatus("All");
                  }}
                >
                  <div
                    className=" d-flex"
                    style={{ height: "50px", border: "1px solid" }}
                  >
                    <span
                      className="card-title font-weight-bolder"
                      style={{
                        fontSize: "20px",
                        margin: "auto",
                        color: jobSelectedStatus == "All" ? "#2d207d" : "white",
                      }}
                    >
                      {t("extra.All")}
                    </span>
                  </div>
                </div>
                <div
                  className="col-md-3"
                  style={{
                    backgroundColor:
                      jobSelectedStatus == "Draft" ? "white" : "#2d207d",
                    marginRight: "1px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOffsetValue(1);
                    setJobSelectedStatus("Draft");
                  }}
                >
                  <div
                    className="d-flex"
                    style={{ height: "50px", border: "1px solid" }}
                  >
                    <span
                      className="card-title font-weight-bolder"
                      style={{
                        fontSize: "20px",
                        margin: "auto",
                        color:
                          jobSelectedStatus == "Draft" ? "#2d207d" : "white",
                      }}
                    >
                      {getLocaleValue("job_summary_status_draft")}
                    </span>
                  </div>
                </div>
                <div
                  className="col-md-3"
                  style={{
                    backgroundColor:
                      jobSelectedStatus == "Pending" ? "white" : "#2d207d",
                    marginRight: "1px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOffsetValue(1);
                    setJobSelectedStatus("Pending");
                  }}
                >
                  <div
                    className="d-flex"
                    style={{ height: "50px", border: "1px solid" }}
                  >
                    <span
                      className="card-title font-weight-bolder"
                      style={{
                        fontSize: "20px",
                        margin: "auto",
                        color:
                          jobSelectedStatus == "Pending" ? "#2d207d" : "white",
                      }}
                    >
                      {getLocaleValue("job_summary_status_pending")}
                    </span>
                  </div>
                </div>
                <div
                  className="col-md-3"
                  style={{
                    backgroundColor:
                      jobSelectedStatus == "Completed" ? "white" : "#2d207d",
                    marginRight: "1px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOffsetValue(1);
                    setJobSelectedStatus("Completed");
                  }}
                >
                  <div
                    className=" d-flex"
                    style={{ height: "50px", border: "1px solid" }}
                  >
                    <span
                      className="card-title font-weight-bolder"
                      style={{
                        fontSize: "20px",
                        margin: "auto",
                        color:
                          jobSelectedStatus == "Completed"
                            ? "#2d207d"
                            : "white",
                      }}
                    >
                      {getLocaleValue("job_summary_status_completed")}
                    </span>
                  </div>
                </div>
                <div></div>{" "}
              </div>
              <div
                className="card card-custom card-stretch gutter-b"
                style={{ marginTop: "10px" }}
              >
                <div className="card-body py-3">
                  {/* <div className="tab-content">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex">
                        <div className="me-3" style={{ width: "100%" }}>
                          <label width='50px' className="mb-1 ms-1 me-3">{t("jobsManagement.filters.labelJobStatus")}</label>
                          <select
                            className="form-select me-3"
                            value={jobSelectedStatus}
                            onChange={(e) =>
                              setJobSelectedStatus(e.target.value)
                            }
                          >
                            {Status.map(({ label, value }) => (
                              <option key={value} value={value}>
                                {label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div>
                    {/* <div class="modal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                        <div class="modal-dialog" >
                                            <div class="modal-content"  style={{width:'700px'}}>
                                            <div class="modal-header">
                                                {/* <h5 class="modal-title" id="exampleModalLabel">Modal title</h5> */}
                    {/* <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleFormClose}></button>
                                            </div>
                                            <div class="modal-body">
                                            <iframe id='fr' name="FormData" width='100%' height={height} src ={iFrameURL} allow=""></iframe>
                                            </div>
                                            <div class="modal-footer"> */}
                    {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                                <button type="button" class="btn btn-primary">Save changes</button> */}
                    {/* </div>
                                            </div>
                                        </div>
                                </div>  */}
                  </div>

                  {loading ? (
                    <Loader
                      type="ThreeDots"
                      color="#ad1a5f"
                      height={40}
                      width={40}
                      style={{ textAlign: "center", marginBottom: "50px" }}
                    />
                  ) : (
                    <div
                      className="table-responsive"
                      style={{ width: "100%", overflowX: "scroll" }}
                    >
                      <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                        <thead>
                          <tr className="text-left">
                            <th
                              className="c-pointer"
                              style={{ width: "75px" }}
                              onClick={() => requestSort("id")}
                            >
                              <span
                                className={
                                  sortConfig && sortConfig.key === "id"
                                    ? "text-secondary"
                                    : "text-dark-75" + " font-15"
                                }
                              >
                                {t("jobsManagement.manageJobs.id")}{" "}
                                {sortConfig &&
                                  sortConfig.key === "id" &&
                                  (sortConfig.direction === "ascending" ? (
                                    <FiArrowUp />
                                  ) : (
                                    <FiArrowDown />
                                  ))}
                              </span>
                            </th>
                            <th
                              className="c-pointer"
                              style={{ width: "150px" }}
                              onClick={() => requestSort("date")}
                            >
                              <span
                                className={
                                  sortConfig && sortConfig.key === "date"
                                    ? "text-secondary"
                                    : "text-dark-75" + " font-15"
                                }
                              >
                                {t("jobsManagement.manageJobs.dateTime")}{" "}
                                {sortConfig &&
                                  sortConfig.key === "date" &&
                                  (sortConfig.direction === "ascending" ? (
                                    <FiArrowUp />
                                  ) : (
                                    <FiArrowDown />
                                  ))}
                              </span>
                            </th>
                            {/* <th
                              className="c-pointer"
                              style={{ width: "150px" }}
                              onClick={() => requestSort("fromUser")}
                            >
                              <span
                                className={
                                  sortConfig && sortConfig.key === "fromUser"
                                    ? "text-secondary"
                                    : "text-dark-75" + " font-15"
                                }
                              >
                                {t("jobsManagement.manageJobs.user")}{" "}
                                {sortConfig &&
                                  sortConfig.key === "fromUser" &&
                                  (sortConfig.direction === "ascending" ? (
                                    <FiArrowUp />
                                  ) : (
                                    <FiArrowDown />
                                  ))}
                              </span>
                            </th> */}
                            <th
                              className="c-pointer"
                              style={{ width: "150px" }}
                              onClick={() => requestSort("status")}
                            >
                              <span
                                className={
                                  sortConfig && sortConfig.key === "status"
                                    ? "text-secondary"
                                    : "text-dark-75" + " font-15"
                                }
                              >
                                {t("jobsManagement.manageJobs.status")}{" "}
                                {sortConfig &&
                                  sortConfig.key === "status" &&
                                  (sortConfig.direction === "ascending" ? (
                                    <FiArrowUp />
                                  ) : (
                                    <FiArrowDown />
                                  ))}
                              </span>
                            </th>
                            {/* <th
                              className="c-pointer"
                              style={{ width: "150px" }}
                              onClick={() => requestSort("department")}
                            >
                              <span
                                className={
                                  sortConfig && sortConfig.key === "department"
                                    ? "text-secondary"
                                    : "text-dark-75"
                                }
                              >
                                {t("jobsManagement.manageJobs.department")}{" "}
                                {sortConfig &&
                                  sortConfig.key === "department" &&
                                  (sortConfig.direction === "ascending" ? (
                                    <FiArrowUp />
                                  ) : (
                                    <FiArrowDown />
                                  ))}
                              </span>
                            </th> */}
                            {/* <th
                              className="c-pointer"
                              style={{ width: "200px" }}
                              onClick={() => requestSort("masterProcess")}
                            >
                              <span
                                className={
                                  sortConfig &&
                                  sortConfig.key === "masterProcess"
                                    ? "text-secondary"
                                    : "text-dark-75"
                                }
                              >
                                {t("jobsManagement.manageJobs.masterProcess")}{" "}
                                {sortConfig &&
                                  sortConfig.key === "masterProcess" &&
                                  (sortConfig.direction === "ascending" ? (
                                    <FiArrowUp />
                                  ) : (
                                    <FiArrowDown />
                                  ))}
                              </span>
                            </th> */}
                            <th
                              className="c-pointer"
                              style={{ width: "200px" }}
                              onClick={() => requestSort("process")}
                            >
                              <span
                                className={
                                  sortConfig && sortConfig.key === "process"
                                    ? "text-secondary"
                                    : "text-dark-75" + " font-15"
                                }
                              >
                                {t("jobsManagement.manageJobs.process")}{" "}
                                {sortConfig &&
                                  sortConfig.key === "process" &&
                                  (sortConfig.direction === "ascending" ? (
                                    <FiArrowUp />
                                  ) : (
                                    <FiArrowDown />
                                  ))}
                              </span>
                            </th>
                            <th
                              style={{
                                width: "100px",
                                position: "sticky",
                                left: "0px",
                                zIndex: "40",
                              }}
                            >
                              <span className="text-dark-75 font-18">
                                {t(
                                  "customerJobReport.manageInformation.action"
                                )}
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.map(
                            ({
                              sno,
                              id,
                              date,
                              fromUser,
                              departmentLocalizationKeys,
                              masterProcessLocalizationKeys,
                              processLocalizationKeys,
                              status,
                              arcKey,
                              editUrl,
                              isEditable,
                              isPayable,
                              isPendingDues,
                              IsRefundable,
                            }) => {
                              let statusClass =
                                status.toLowerCase() === "completed"
                                  ? "success"
                                  : status.toLowerCase() === "cancelled"
                                  ? "danger"
                                  : "warning";
                              return (
                                <tr key={sno}>
                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {id}
                                    </span>
                                  </td>

                                  <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {date}
                                    </span>
                                  </td>
                                  {/* <td>
                                    <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                      {fromUser}
                                    </span>
                                  </td> */}

                                  <td>
                                    <span
                                      className={
                                        "label me-1 label-outline-" +
                                        statusClass
                                      }
                                      style={{
                                        borderRadius: "3px",
                                        width: "auto",
                                      }}
                                    >
                                      {t(arcKey)}
                                    </span>
                                  </td>
                                  <td
                                    style={{ whiteSpace: "wrap" }}
                                    className="pl-0 py-8"
                                  >
                                    <div className="d-flex">
                                      <span
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                        }}
                                        className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg"
                                      >
                                        {"D :" + " "}
                                      </span>
                                      <span>
                                        {" "}
                                        {getLocaleValue(
                                          departmentLocalizationKeys.name
                                        )}
                                      </span>
                                    </div>
                                    {/* </td>
                                  <td> */}
                                    <div className="d-flex">
                                      <span
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                        }}
                                        className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg"
                                      >
                                        {"M :" + " "}
                                      </span>
                                      <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                        {getLocaleValue(
                                          masterProcessLocalizationKeys.name
                                        )}
                                      </span>
                                    </div>

                                    {/* </td>
                                  <td> */}
                                    <div className="d-flex">
                                      <span
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                        }}
                                        className="text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg"
                                      >
                                        {"P :" + " "}
                                      </span>
                                      <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                                        {getLocaleValue(
                                          processLocalizationKeys.name
                                        )}
                                      </span>
                                    </div>
                                  </td>

                                  <td
                                    className="pr-0"
                                    style={{ position: "sticky" }}
                                  >
                                    <div>
                                      <div
                                        className="m-2 c-pointer"
                                        onClick={() => {
                                          setMenuId(id);
                                          id == menuId
                                            ? setMenuId(0)
                                            : setMenuId(id);
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="16"
                                          fill="currentColor"
                                          class="bi bi-three-dots"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                        </svg>
                                      </div>

                                      {menuId == id &&
                                        (status != "Draft" ||
                                          status != "Awaiting Payment") && (
                                          <div
                                            className="m-2 c-pointer"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              history.push(`/jobs/${id}`);
                                              IsRefundable = IsRefundable;
                                              setMenuId(true);
                                            }}
                                            onMouseEnter={() => {
                                              setIsOnView(true);
                                            }}
                                            onMouseLeave={() => {
                                              setIsOnView(false);
                                            }}
                                          >
                                            {" "}
                                            {isOnView && (
                                              <div
                                                className="popover position-absolute fade show bs-popover-start"
                                                style={{
                                                  top: "0px",
                                                  width: "100px",
                                                  left: "-100px",
                                                }}
                                              >
                                                <p
                                                  className="m-0 p-3 popover-body"
                                                  dangerouslySetInnerHTML={{
                                                    __html: "View",
                                                  }}
                                                />
                                              </div>
                                            )}
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              class="bi bi-list"
                                              viewBox="0 0 16 16"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
                                              />
                                            </svg>
                                          </div>
                                          //   <p
                                          //     onClick={() => {
                                          //       history.push(`/jobs/${id}`);
                                          //       IsRefundable = IsRefundable;
                                          //     }}
                                          //     className="btn btn-info font-weight-bolder font-size-sm me-2"
                                          //   >
                                          //     {t(
                                          //       "customerJobReport.manageInformation.view"
                                          //     )}
                                          //   </p>
                                        )}
                                      {menuId == id && isEditable && (
                                        <div
                                          className="m-2 c-pointer"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            handleFormEditUrl(editUrl);
                                            setShowIFrameModal(true);
                                          }}
                                          onMouseEnter={() => {
                                            setIsOnUpdate(true);
                                          }}
                                          onMouseLeave={() => {
                                            setIsOnUpdate(false);
                                          }}
                                        >
                                          {isOnUpdate && (
                                            <div
                                              className="popover position-absolute fade show bs-popover-start"
                                              style={{
                                                top: "30px",
                                                width: "100px",
                                                left: "-100px",
                                              }}
                                            >
                                              <p
                                                className="m-0 p-3 popover-body"
                                                dangerouslySetInnerHTML={{
                                                  __html: "Edit",
                                                }}
                                              />
                                            </div>
                                          )}
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-pencil-square"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                            <path
                                              fillRule="evenodd"
                                              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                            />
                                          </svg>
                                        </div>

                                        //   <p
                                        //     onClick={() => {
                                        //       handleFormEditUrl(editUrl);
                                        //       setShowIFrameModal(true);
                                        //     }}
                                        //     className="btn btn-success font-weight-bolder font-size-sm me-2"
                                        //   >
                                        //     {t(
                                        //       "customerJobReport.manageInformation.update"
                                        //     )}
                                        //   </p>
                                      )}
                                      {menuId == id && isPayable && (
                                        <div
                                          className="m-2 c-pointer"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            history.push(`checkout/${id}`)
                                          }
                                          onMouseEnter={() => {
                                            setIsOnPay(true);
                                          }}
                                          onMouseLeave={() => {
                                            setIsOnPay(false);
                                          }}
                                        >
                                          {isOnPay && (
                                            <div
                                              className="popover position-absolute fade show bs-popover-start"
                                              style={{
                                                top: "60px",
                                                width: "100px",
                                                left: "-100px",
                                              }}
                                            >
                                              <p
                                                className="m-0 p-3 popover-body"
                                                dangerouslySetInnerHTML={{
                                                  __html: "Payment",
                                                }}
                                              />
                                            </div>
                                          )}
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-currency-exchange"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M0 5a5.002 5.002 0 0 0 4.027 4.905 6.46 6.46 0 0 1 .544-2.073C3.695 7.536 3.132 6.864 3 5.91h-.5v-.426h.466V5.05c0-.046 0-.093.004-.135H2.5v-.427h.511C3.236 3.24 4.213 2.5 5.681 2.5c.316 0 .59.031.819.085v.733a3.46 3.46 0 0 0-.815-.082c-.919 0-1.538.466-1.734 1.252h1.917v.427h-1.98c-.003.046-.003.097-.003.147v.422h1.983v.427H3.93c.118.602.468 1.03 1.005 1.229a6.5 6.5 0 0 1 4.97-3.113A5.002 5.002 0 0 0 0 5zm16 5.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0zm-7.75 1.322c.069.835.746 1.485 1.964 1.562V14h.54v-.62c1.259-.086 1.996-.74 1.996-1.69 0-.865-.563-1.31-1.57-1.54l-.426-.1V8.374c.54.06.884.347.966.745h.948c-.07-.804-.779-1.433-1.914-1.502V7h-.54v.629c-1.076.103-1.808.732-1.808 1.622 0 .787.544 1.288 1.45 1.493l.358.085v1.78c-.554-.08-.92-.376-1.003-.787H8.25zm1.96-1.895c-.532-.12-.82-.364-.82-.732 0-.41.311-.719.824-.809v1.54h-.005zm.622 1.044c.645.145.943.38.943.796 0 .474-.37.8-1.02.86v-1.674l.077.018z" />
                                          </svg>
                                        </div>
                                        //   <p
                                        //     onClick={() =>
                                        //       history.push(`checkout/${id}`)
                                        //     }
                                        //     className="btn btn-primary font-weight-bolder font-size-sm me-2"
                                        //   >
                                        //     {t(
                                        //       "customerJobReport.manageInformation.pay"
                                        //     )}
                                        //   </p>
                                      )}
                                      {menuId == id && isPendingDues && (
                                        <div
                                          className="m-2 c-pointer"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            history.push(
                                              `additionalPayment/${id}`
                                            )
                                          }
                                          onMouseEnter={() => {
                                            setIsOnAdditionalPayment(true);
                                          }}
                                          onMouseLeave={() => {
                                            setIsOnAdditionalPayment(false);
                                          }}
                                        >
                                          {isOnAddtionalPayment && (
                                            <div
                                              className="popover position-absolute fade show bs-popover-start"
                                              style={{
                                                top: "60px",
                                                width: "100px",
                                                left: "-100px",
                                              }}
                                            >
                                              <p
                                                className="m-0 p-3 popover-body"
                                                dangerouslySetInnerHTML={{
                                                  __html: "Pay Dues",
                                                }}
                                              />
                                            </div>
                                          )}
                                          <img
                                            src="/Assets/paydues.svg"
                                            height={"16px"}
                                            width={"16px"}
                                            style={{ margin: "auto" }}
                                          />
                                        </div>
                                        //   <p
                                        //     onClick={() =>
                                        //       history.push(`checkout/${id}`)
                                        //     }
                                        //     className="btn btn-primary font-weight-bolder font-size-sm me-2"
                                        //   >
                                        //     {t(
                                        //       "customerJobReport.manageInformation.pay"
                                        //     )}
                                        //   </p>
                                      )}
                                      {menuId == id &&
                                        (status == "Draft" ||
                                          status == "Awaiting Payment") && (
                                          <div
                                            className="m-2 c-pointer"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              setShowDeleteModal(true);
                                              setDeleteId(id);
                                            }}
                                            onMouseEnter={() => {
                                              setIsOnDelete(true);
                                            }}
                                            onMouseLeave={() => {
                                              setIsOnDelete(false);
                                            }}
                                          >
                                            {isOnDelete && (
                                              <div
                                                className="popover position-absolute fade show bs-popover-start"
                                                style={{
                                                  top: "90px",
                                                  width: "100px",
                                                  left: "-100px",
                                                }}
                                              >
                                                <p
                                                  className="m-0 p-3 popover-body"
                                                  dangerouslySetInnerHTML={{
                                                    __html: "Delete",
                                                  }}
                                                />
                                              </div>
                                            )}
                                            {/* <div className="m-2" style={{cursor: 'pointer'}} onClick={() => handleFormDelete(id)}> */}
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="currentColor"
                                              class="bi bi-trash3"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                                            </svg>
                                          </div>
                                          //   <p
                                          //     onClick={() => handleFormDelete(id)}
                                          //     className="btn btn-danger font-weight-bolder font-size-sm me-2"
                                          //   >
                                          //     {t(
                                          //       "customerJobReport.manageInformation.delete"
                                          //     )}
                                          //   </p>
                                        )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                      {pageCount > 1 && currentItems.length > 0 && (
                        // <ReactPaginate
                        //   breakLabel="..."
                        //   nextLabel=">"
                        //   previousLabel="<"
                        //   onPageChange={handlePageClick}
                        //   pageRangeDisplayed={5}
                        //   pageCount={pageCount}
                        //   pageClassName="page-item"
                        //   pageLinkClassName="page-link"
                        //   previousClassName="page-item"
                        //   previousLinkClassName="page-link"
                        //   nextClassName="page-item"
                        //   nextLinkClassName="page-link"
                        //   breakClassName="page-item"
                        //   breakLinkClassName="page-link"
                        //   containerClassName="pagination"
                        //   activeClassName="active"
                        //   renderOnZeroPageCount={null}
                        // />
                        <CustomPagination
                          totalCount={totalCount}
                          pageSize={itemsPerPage}
                          currentPage={offSetValue}
                          onPageChange={handlePageClick}
                          siblingCount={2}
                        ></CustomPagination>
                      )}
                      {data.length === 0 && (
                        <p className="text-center mt-5 mb-5">
                          {t("jobsManagement.noDataAvailable")}
                        </p>
                      )}
                    </div>
                  )}
                  {data.length > 0 && (
                    <p>{`Showing ${dataFrom} to ${
                      itemsPerPage > items.length
                        ? dataFrom + items.length - 1
                        : dataFrom + (itemsPerPage - 1)
                    } of ${totalCount} entries`}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          {showIFrameModal && (
            <IFrameModal
              url={iFrameURL}
              handleCancel={handleFormClose}
              showModal={showIFrameModal}
            >
              {" "}
            </IFrameModal>
          )}
          {showDeleteModal && (
            <DeleteModal
              handleCancel={handleDeleteModalClose}
              showModal={showDeleteModal}
              handleOk={handleFormDelete}
              loading={deleteButtonLoading}
              footerOption1={"Delete"}
              footerOption2={"Cancel"}
            ></DeleteModal>
          )}
        </div>
      )}
    </>
  );
};

export default JobsManagement;
